import React from 'react';
import Responsive from 'react-responsive';

export const DesktopWidthL='1024px';
export const DesktopWidthM='512px';
export const DesktopWidthS='256px';
export const PageSize = {
	Height : '100vh',
	Width : '100%'
};
export const HeaderSize = {
	Width : '100%',
};

export const SidebarSize = {
	Width : '15vw',
};
export const MainContainerSize = {
	Height : '100%',
	Width : '100%',
};
export const CreateQuizSize = {
	RecipeListWidth : '40%',
	QuizListWidth : '60%',
	Height : '90vh',
};

export const RecipeDetailSize = {
	Height : '90vh',
};

export const SearchQuizSize = {
	Height : '90vh',
	Width : '100%',
	CardWidth : '20%',
	CardHeight : '30%'
};
export const PlayQuizSize = {
	Height : '83vh',
	Width : '100%',
};

export const LandingpageSize = {
	Height : '90vh',
	Width : '80vw',
};

export const Desktop = props => <Responsive {...props} minWidth={992} />;
export const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />;
export const Mobile = props => <Responsive {...props} maxWidth={767} />;
export const Default = props => <Responsive {...props} minWidth={768} />;